<template>

  <svg
    t="1639127743337"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M558.434375 667.221875a28.51875 28.51875 0 0 1 0 40.33125l-181.490625 181.490625a57.0375 57.0375 0 0 1-80.6625 0L134.95625 727.71875a57.0375 57.0375 0 0 1 0-80.6625l181.490625-181.490625a28.51875 28.51875 0 1 1 40.33125 40.33125l-181.490625 181.490625 161.325 161.325 181.490625-181.490625a28.51875 28.51875 0 0 1 40.33125 0z m60.496875-262.153125a28.51875 28.51875 0 0 1 0 40.33125l-201.65625 201.65625a28.51875 28.51875 0 0 1-40.33125-40.33125l201.65625-201.65625a28.51875 28.51875 0 0 1 40.33125 0z m241.9875-80.6625a57.0375 57.0375 0 0 1 0 80.6625l-181.490625 181.490625a28.51875 28.51875 0 1 1-40.33125-40.33125l181.490625-181.490625-161.325-161.325-181.490625 181.490625a28.51875 28.51875 0 1 1-40.33125-40.33125l181.490625-181.490625a57.0375 57.0375 0 0 1 80.6625 0l161.325 161.325z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLink',
} as DefineComponent
</script>